var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'text-expandable': _vm.isExpandable },on:{"click":_vm.toggleExpanded}},[(_vm.showFullText)?[_vm._v(" "+_vm._s(_vm.text)+" ")]:[_vm._v(" "+_vm._s(_vm.cutoffText)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }